import React from 'react';
import { componentMap } from './componentMap';
import { SearchTabProvider } from './SearchTabContext';

function WebsiteRenderer({ layout, branding = {} }) {
  if (!layout) {
    return <div>Loading Preview...</div>;
  }

  // Get the single-choice components
  const TopBarComponent = componentMap[layout.topBar];
  const HeaderComponent = componentMap[layout.header];
  const HeroComponent = componentMap[layout.hero];
   const DestinationsComponent = componentMap[layout.destinations];
  const PackagesComponent = componentMap[layout.packages];
  const TestimonialsComponent = componentMap[layout.testimonials];
  const AboutUsComponent = componentMap[layout.aboutUs];
  const FooterComponent = componentMap[layout.footer];

  return (
    <div>
      {/* Render single-choice components */}
      {TopBarComponent && layout.topBar !== 'None' && <TopBarComponent branding={branding} />}
       <SearchTabProvider>
      {HeaderComponent && <HeaderComponent branding={branding} />}
      {HeroComponent && <HeroComponent branding={branding} />}
      </SearchTabProvider>
      
      {/* --- THIS IS THE HYBRID RENDERING LOGIC --- */}
     {DestinationsComponent && layout.destinations !== 'None' && <DestinationsComponent branding={branding} />}
      {PackagesComponent && layout.packages !== 'None' && <PackagesComponent branding={branding} />}
      {/* 2. Render the other single-choice sections */}
      {TestimonialsComponent && layout.testimonials !== 'None' && <TestimonialsComponent branding={branding} />}
      {AboutUsComponent && layout.aboutUs !== 'None' && <AboutUsComponent branding={branding} />}
      
      {/* Render the footer */}
      {FooterComponent && <FooterComponent branding={branding} />}
    </div>
  );
}

export default WebsiteRenderer;